module.exports = __webpack_public_path__ + "static/vascepaStatin-44e74b72487b4e8c68325c499101d924.png";